import { useTranslation } from "react-i18next";
import { useUser } from "../../../../../context/userContext";
import { useNavigate } from "react-router-dom";
import { useId, useState } from "react";
import { toast } from "react-toastify";
import { Box, SpanStyled } from "../../../../../components/styled/Elements";
import { ShareIcon } from "../../../../../components/styled/AllImages";
import ShareModal from "../../../../../components/auth/Modal/ShareProfileModal";

import { resolveMediaUrl } from "../../../../../utils/mediaUrl";
import {
  buildProfilePath,
  isValidProfileUsername,
} from "../../../../../utils/profileUsername";
const WEBSITE_BASE_URL = process.env.REACT_APP_WEBSITE_URL;

const VisitorBanner = ({ username, coverImg }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(
    coverImg ? resolveMediaUrl(coverImg) : null
  );
  const uniqueId = useId();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setSelectedImage(fileURL);
    }
  };

  const profilePath = buildProfilePath(username);
  const profileUrl = profilePath ? `${WEBSITE_BASE_URL}${profilePath}` : null;

  const openShareModal = () => {
    if (!isValidProfileUsername(username)) {
      toast.error(t("profile_not_found"));
      return;
    }

    setShowModal(true);
  };

  return (
    <Box className="bannerImg">
      {selectedImage && <img src={selectedImage} />}

      <SpanStyled
        className="share-icon px-3 py-2 bg-white rounded-2"
        style={{
          cursor: "pointer",
        }}
        onClick={openShareModal}
        title={t("share_profile")}
      >
        <ShareIcon />
      </SpanStyled>
      <input
        id={`imageInput-${uniqueId}`} // Use the unique ID here
        type="file"
        accept="image/png, image/jpeg, image/jpg" // Accept only image files
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <ShareModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        cardLink={profileUrl || ""}
      />
    </Box>
  );
};
export default VisitorBanner;
